import { IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';

import uiStyles from "../../../Lib/UI/UI.module.css";
import { IPlaceSearchResult } from '../placeSearchTypes';


interface SearchPlacesListItemActionsProps {
    item: IPlaceSearchResult,
    onView: (item: IPlaceSearchResult) => void;
    disabled?: boolean;
}

const SearchPlacesListItemActions = (props: SearchPlacesListItemActionsProps): JSX.Element => {
    return (
        <>
            <IconButton edge="end" aria-label="View on map..." title="View on map..." className={uiStyles.list_action} onClick={() => props.onView(props.item)} disabled={props.disabled}>
                <VisibilityIcon fontSize='large' />
            </IconButton>
        </>
    );
};

export default SearchPlacesListItemActions;